export default "__VITE_ASSET__Crw69oyr__"